import { render } from "./SelectContent.vue?vue&type=template&id=27f0a7e0&ts=true"
import script from "./SelectContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectContent.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/select/SelectContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27f0a7e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27f0a7e0', __exports__)) {
    api.reload('27f0a7e0', __exports__)
  }
  
  module.hot.accept("./SelectContent.vue?vue&type=template&id=27f0a7e0&ts=true", () => {
    api.rerender('27f0a7e0', render)
  })

}


export default __exports__